import { render } from "./EntitiesContacts.vue?vue&type=template&id=bf995f84&scoped=true"
import script from "./EntitiesContacts.vue?vue&type=script&lang=js"
export * from "./EntitiesContacts.vue?vue&type=script&lang=js"

import "./EntitiesContacts.vue?vue&type=style&index=0&id=bf995f84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf995f84"]])

export default __exports__